
import { Component, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LucideAngularModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  public production: boolean = environment.production;

  ngOnInit() {
    this.initializeFooterInfo();
  }

  private initializeFooterInfo() {
    // Llenar versión del build
    const versionEl = document.getElementById('version_app');
    if (versionEl) {
      versionEl.textContent = `v${environment.version}`;
    }

    // Llenar información del build
    const buildEl = document.getElementById('build_app');
    if (buildEl) {
      buildEl.textContent = `Build: ${environment.build}`;
    }
  }
}
